import type { PropsWithChildren } from 'react'
import { Container } from '@shared/components/container'
import styled from 'styled-components'

export const VerifLayout = ({ children }: PropsWithChildren) => {
	return (
		<Wrap>
			<Main>
				<Container>
					{children}
				</Container>
			</Main>
			<Footer>©{new Date().getFullYear()} Информационная система Credit.Club</Footer>
		</Wrap>
	)
}

const Wrap = styled.div({
	display: 'flex',
	flexDirection: 'column',
	height: '100dvh',
	justifyContent: 'space-between',
})

const Main = styled.main({
	display: 'flex',
	flex: 1,
})

const Footer = styled.div(({ theme }) => ({
	...theme.typography.text14_20,
	color: theme.colors.gray4,
	marginBottom: 10,
	marginLeft: 12,

	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 16,
		marginLeft: 24,
	},
}))
